import FingerprintJS from '@fingerprintjs/fingerprintjs';

const STORAGE_KEY = 'locsy_operator_install_id';

let fpPromise = null;

const getOrCreateInstallId = () => {
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = `${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    return `${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
  }
};

/**
 * Browser device id + platform for operator single-device binding
 * (aligned with LOCSY Dashboard web: locsy_web_* / platform web).
 */
export const getOperatorDeviceBindingPayload = async () => {
  let visitorId = null;
  try {
    if (!fpPromise) {
      fpPromise = FingerprintJS.load();
    }
    const fp = await fpPromise;
    const result = await fp.get();
    visitorId = result?.visitorId || null;
  } catch {
    visitorId = null;
  }

  const raw = visitorId || getOrCreateInstallId();
  const normalized = String(raw).replace(/[^a-zA-Z0-9_-]/g, '');
  return {
    deviceId: `locsy_web_${normalized}`,
    platform: 'web',
  };
};
